import Home from "../views/Home";

export default function root()
{
    return(
        <Home/>
    );
}